import React, { useCallback } from "react"
import { SurveyModal } from "../../../../../components/templates/modals/survey"
import { ICreateScaleSurveyProps as IScaleSurveyProps } from "../../../../../components/templates/surbey/create/create-scale-survey"
import { ICreateSelectSurveyProps as ISelectSurveyProps } from "../../../../../components/templates/surbey/create/create-select-survey"
import { JSONRPCErrorCatch } from "../../../../../error/error"
import { convertEditorContentFromContent } from "../../../../../libs/converter/convert-editor-episode-from-episode"
import { CreateContent } from "../../../../../libs/create-content"
import { createSurvey } from "../../../../../models/ChatRoom"
import { SurveySituation } from "../../../../../rpcs/dist/ChatRoomRPC"
import { container, IContainerProps } from "./container"

export const CreateSurvey = container((props: IContainerProps) => {
  const onSubmit = useCallback(
    async (p: ISelectSurveyProps & IScaleSurveyProps) => {
      const res = await createSurvey(props.chatRoom!.displayId, {
        surveyModel: p.surveyModel,
        surveySituation: SurveySituation.Episode,
        subject: p.title,
        questions: p.answers,
      }).catch(JSONRPCErrorCatch)

      if (res !== -1) {
        props.contentActions.insertContent(
          convertEditorContentFromContent(CreateContent.Survey(null, res.id)),
          props.uuid!,
        )
        props.actions.closeSurveyModal()
      }
    },
    // eslint-disable-next-line
    [props.uuid],
  )

  const onClose = useCallback(() => {
    props.actions.closeSurveyModal()
    // eslint-disable-next-line
  }, [])

  if (props.uuid) {
    return <SurveyModal onClose={onClose} onSubmit={onSubmit} />
  }

  return null
})
